import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { LabeledBooleanInput } from './LabeledBooleanInput.es.js';

const LabeledRadio = (_a) => {
  var { disabled, isDisabled } = _a, props = __rest(_a, ["disabled", "isDisabled"]);
  return jsx(LabeledBooleanInput, Object.assign({}, props, { isDisabled: disabled || isDisabled, type: "radio" }));
};

export { LabeledRadio };
//# sourceMappingURL=LabeledRadio.es.js.map
